import React from 'react';
import VendorStepLogin from "../VendorStepLogin";
import HeaderResponsive from "../HeaderResponsive";
import UploadFiles from "./UploadFiles";
import {Link} from "react-router-dom";

const VendorUploadFile = () => {
    return (
        <div className="vendor-upload-file-wrapper">
            <div className="row">
                <div className="col-lg-5 order-2 order-lg-1">
                    <VendorStepLogin step="step--2"/>
                </div>
                <div className="col-lg-7 order-1 order-lg-2">
                    <HeaderResponsive/>
                    <div className="upload-file-wrapper">
                        <h3 className="upload-file-title xmb-6">مالیات بر ارزش افزوده</h3>
                        <div className="question-box">
                            <p className="question">آیا مشمول مالیات بر ارزش افزوده می باشید؟
                            </p>
                            <p className="description">توجه نمایید برگه ارزش افزوده حقیقی باید به نام شخص ثبت نام کننده
                                باشد</p>
                            <div className="form-check d-flex xmt-6">
                                <input className="form-check-input" type="radio" name="flexRadioDefault"
                                       id="upload-question-option--1"/>
                                <label className="form-check-label" htmlFor="upload-question-option--1">
                                    بلی
                                </label>
                                <input className="form-check-input xmr-22" type="radio" name="flexRadioDefault"
                                       id="upload-question-option--2"/>
                                <label className="form-check-label" htmlFor="upload-question-option--2">
                                    خیر
                                </label>
                            </div>
                        </div>
                        <UploadFiles/>
                        <div className="register-button xmt-12 d-flex flex-row-reverse">
                            <Link to="/successLoginVendor" className="button">ثبت نهایی</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorUploadFile;
